import { ReactNode, createContext, useContext } from 'react'
import { Form } from '$components'
import dayjs from 'dayjs'
import { RescheduleAppointmentFormControls } from './controls'
import { RescheduleAppointmentFormContent } from './content'
import { RescheduleAppointmentSchema, rescheduleAppointmentSchema } from './schema'

type RescheduleAppointmentFormContextType = {
  onSubmit: (values: RescheduleAppointmentSchema) => void
  onCancel: () => void
  isLoading?: boolean
  defaultValues?: Partial<RescheduleAppointmentSchema>
}

const RescheduleAppointmentFormContext = createContext<RescheduleAppointmentFormContextType | undefined>(undefined)

type RescheduleAppointmentFormProps = {
  onSubmit: (values: RescheduleAppointmentSchema) => void
  onCancel: () => void
  defaultValues?: Partial<RescheduleAppointmentSchema>
  isLoading?: boolean
  children?: ReactNode
}

export function RescheduleAppointmentForm({
  onSubmit,
  onCancel,
  defaultValues = {},
  isLoading = false,
  children,
}: RescheduleAppointmentFormProps) {
  const today = dayjs.utc()

  const context: RescheduleAppointmentFormContextType = {
    onSubmit,
    onCancel,
    isLoading,
    defaultValues,
  }

  return (
    <RescheduleAppointmentFormContext.Provider value={context}>
      <Form<RescheduleAppointmentSchema, typeof rescheduleAppointmentSchema>
        schema={rescheduleAppointmentSchema}
        onSubmit={onSubmit}
        defaultValues={{
          date: today.toISOString(),
          ...defaultValues,
        }}
      >
        {children}
      </Form>
    </RescheduleAppointmentFormContext.Provider>
  )
}

RescheduleAppointmentForm.Content = RescheduleAppointmentFormContent
RescheduleAppointmentForm.Controls = RescheduleAppointmentFormControls

export function useRescheduleAppointmentForm() {
  const context = useContext(RescheduleAppointmentFormContext)

  if (context === undefined) {
    throw new Error('useRescheduleAppointmentForm must be used within a RescheduleAppointmentFormProvider')
  }

  return context
}
